import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { PricingCard } from './components/PricingCard';
import { Testimonials } from './components/Testimonials';
import { TomiSection } from './components/TomiSection';
import { UrgencyBanner } from './components/UrgencyBanner';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
export function App() {
  useEffect(() => {
    const metaWindow = window as Window & {
      fbq?: PixelFunction;
      _fbq?: PixelFunction;
    };
    try {
      if (!metaWindow.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as PixelFunction;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        metaWindow.fbq = pixel;
        metaWindow._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      metaWindow.fbq?.('init', '1358713739554000');
      metaWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3dm5vhr4ku4d2">
        <img src="https://www.facebook.com/tr?id=1358713739554000&ev=PageView&noscript=1" height="1" width="1" style={{
        display: 'none'
      }} alt="" data-id="element-1" data-mp="3dii694660445" />
      </noscript>
      <main className="min-h-screen w-full overflow-x-hidden bg-brand-coal" data-id="element-2" data-mp="35yq6nee9s31">
        <div className="mx-auto w-full max-w-3xl bg-white shadow-[0_0_48px_rgba(132,204,22,0.12)]" data-id="element-3" data-mp="38b2ol1dva8p">
          <UrgencyBanner data-id="element-4" data-mp="d4nx5l4r5s4i" />
          <Hero data-id="element-5" data-mp="d57d4waue6fw" />
          <PainSection data-id="element-6" data-mp="d3mil6oj2ni1" />
          <TomiSection data-id="element-7" data-mp="d3wbp34vdary" />
          <BonusSection data-id="element-8" data-mp="85l3ewu838bu" />
          <PricingCard data-id="element-9" data-mp="851n1kk80rzx" />
          <Guarantee data-id="element-10" data-mp="86w76wno4g2y" />
          <Testimonials data-id="element-11" data-mp="86ckz3qzj5j4" />
          <FAQ data-id="element-12" data-mp="3gle9ehqxh1en" />
          <FinalCTA data-id="element-13" data-mp="3gkv0fqj99ncr" />
          <Footer data-id="element-14" data-mp="3gmfu7dxqx29k" />
        </div>
      </main>
    </>;
}